import PublicHttpClient from '../../services/public-http-client';
import { Pagination } from '../../../model/pagination';
import { IAccountReportPagedRequest } from '../../../model/sge/account-report/request/account-report-paged-request';
import { IAccountReportResponse } from '../../../model/sge/account-report/response/account-report-response';

const basePath = (clientId: number, amendmentId: number) => `Public/Client/${clientId}/Amendment/${amendmentId}/AccountReports`;

const list = async (clientId: number, amendmentId: number, params: Omit<IAccountReportPagedRequest, 'amendmentId'>): Promise<Pagination<IAccountReportResponse>> => {
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(clientId, amendmentId)}`,
        params
    }).then((response) => Object.assign(new Pagination<IAccountReportResponse>(), response.data));
};

const PublicAccountReportAppService = { list };
export default PublicAccountReportAppService;
